import { jsx as o } from "react/jsx-runtime";
import s from "react";
import { RangoBadge as f } from "./Badge.js";
import { R as b, I as h } from "../chunks/index.cff5baaf.js";
import n, { css as a } from "styled-components";
const i = {
  SM: "sm",
  MD: "md",
  LG: "lg"
};
Object.values(i);
const I = n.div.withConfig({
  displayName: "Avatar",
  componentId: "sc-8kpu36-0"
})(["align-items:center;background-color:var(--elements-bg-color-02);display:inline-flex;justify-content:center;position:relative;", " ", " ", ""], ({
  src: r
}) => r && a(["background-position:center;background-repeat:no-repeat;background-size:cover;"]), ({
  size: r
}) => r && a(["border-radius:", ";height:", ";width:", ";"], t[r].border, t[r].size, t[r].size), ({
  size: r
}) => r === i.LG && a(["", "{top:var(--size-half);right:var(--size-half);}"], d)), z = n(b).withConfig({
  displayName: "Icon",
  componentId: "sc-8kpu36-1"
})(["color:var(--on-elements-icon-color);"]), d = n.div.withConfig({
  displayName: "BadgeWrapper",
  componentId: "sc-8kpu36-2"
})(["position:absolute;right:0;top:0;"]), t = {
  sm: {
    border: "var(--default-border-radius)",
    size: "var(--size-6x)"
  },
  md: {
    border: "var(--border-radius-md)",
    size: "var(--size-8x)"
  },
  lg: {
    border: "var(--border-radius-lg)",
    size: "var(--size-12x)"
  }
}, k = s.forwardRef(({
  size: r = i.MD,
  src: e = "",
  showNotification: c = !1,
  ariaLabel: u,
  ...l
}, p) => {
  const g = () => {
    if (c)
      return /* @__PURE__ */ o(d, { children: /* @__PURE__ */ o(f, {}) });
  }, m = () => {
    if (!e)
      return /* @__PURE__ */ o(z, { icon: "BusinessLine", size: h[r.toUpperCase()] });
  }, v = () => {
    if (e)
      return {
        backgroundImage: `url(${e})`
      };
  };
  return (() => s.createElement(I, {
    size: r,
    src: e,
    style: v(),
    ref: p,
    role: "img",
    "aria-label": u,
    "data-rango-component": "rango-avatar-business",
    "data-is-rango": !0,
    ...l
  }, g(), m()))();
});
k.displayName = "RangoAvatarBusiness";
export {
  i as AvatarBusinessSize,
  k as RangoAvatarBusiness
};
